import { Component, OnInit } from '@angular/core';
import { LanguagePickerService } from './language-picker.service';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {

    currentLanguage: string;
    supportedLanguages: Array<string>;

    constructor(
        private languagePickerService: LanguagePickerService
    ) {}

    ngOnInit(): void {
        this.supportedLanguages = this.languagePickerService.getSupportedLanguages();
        this.languagePickerService.getLanguage().subscribe(lang => this.currentLanguage = lang);
    }

    public changeLanguage(language: string): void {
        this.languagePickerService.changeLanguage(language);
    }
}